import * as angular from "angular";

export class TasksDialogService {

  constructor(private $mdDialog) {
  }


  confirmDetailedServiceTimeChange(originDetailedServiceTime, updatedDetailedServiceTime) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/confirm-detailed-service-time-change-dialog.html').default,
      parent: angular.element(document.body),
      controller: function ($scope) {

        $scope.updatedDetailedServiceTime = angular.copy(updatedDetailedServiceTime);
        $scope.originDetailedServiceTime = originDetailedServiceTime;
        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////

        $scope.onChangeValue = (value, path) => {
          $scope.updatedDetailedServiceTime[path] = value;
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.updatedDetailedServiceTime);
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

}

angular
  .module('bringoz.admin.tasks')
  .service('tasksDialogService', TasksDialogService);
